import { FlowerProps } from '../../../lib/types'
import { FlowerHappy, FlowerSleepy } from './variants'

export const Flower = ({ ...props }: FlowerProps) => {
  switch (props.face) {
    case 'happy':
      return <FlowerHappy {...props} />
    case 'sleepy':
      return <FlowerSleepy {...props} />
    default:
      return <FlowerHappy {...props} />
  }
}
